// eslint-disable-next-line
import Request from './Request';

const http = new Request();

export default http;
